import { List, Record } from 'immutable';
import { makeScopeKey } from './MarketplaceAppScopes';
import { _makeUser, makeUserFromSPIUser } from './User';
export const makeUserGrant = Record({
  scopes: List(),
  revokeInProgress: false,
  time: new Date(),
  user: _makeUser() // Using internal unsafe constructor for default
});
export const makeUserGrantFromSPIUserGrant = spiUserGrant => makeUserGrant({
  user: makeUserFromSPIUser(spiUserGrant.user),
  scopes: List(spiUserGrant.scopes).map(makeScopeKey),
  time: spiUserGrant.time
});